// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"234":"a7d2f60e","239":"d083094b","348":"11e5d2a9","400":"46c0a0a7","448":"f1596af7","455":"bff2bd14","501":"86d39e00","664":"3f8d2c15","685":"4332e7bd","759":"a0878cd3","886":"9cb0d02d","977":"311e53aa"}[chunkId] + ".chunk.js";
};